export type NativeBackAction = 'navigate-back' | 'exit-app'

export function getNativeBackAction(backGuardArmed: boolean): NativeBackAction {
  return backGuardArmed ? 'navigate-back' : 'exit-app'
}
